import { render, staticRenderFns } from "./ImageGalleryRoute.vue?vue&type=template&id=49ef6cf1&scoped=true&"
import script from "./ImageGalleryRoute.vue?vue&type=script&lang=js&"
export * from "./ImageGalleryRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef6cf1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
